<template>
    <div>
        <!-- These results are for GLASSES and MEDICALCARE -->
        <div class="form-group row">
            <!--This simulate the presence of a label-->
            <label for="socialSecurityRefund" :class="columnForLabels"></label>
            <!-- Desktop resp. labels -->
            <div class="text-center" v-for="complexResult in complexRefundResults" :key="complexResult.type" :class="columnForResults + ' align-self-end d-none d-lg-block'">
                <info-tooltip v-if="complexResult.type !== 'NO'" :id="complexResult.type" :html-text="textForTooltip(complexResult.type)"></info-tooltip>
                <label>{{ textFromType(complexResult.type) }}</label>
            </div>
            <!-- End of Desktop resp.--> 
        </div>
        <div class="form-group row">
            <label for="socialSecurityRefund" :class="columnForLabels"><strong>{{ text.socialSecurityRefund }}</strong></label>
            <div v-for="complexResult in complexRefundResults" :key="complexResult.type" :class="columnForResults">
                <div class="row">
                    <!-- Mobile resp. labels -->
                    <div class="d-block d-lg-none col-8">
                        <label>{{ textFromType(complexResult.type) }}</label>
                    </div>
                    <div class="d-block d-lg-none col-1">
                        <info-tooltip v-if="complexResult.type !== 'NO'" :id="complexResult.type + '-mobile'" :html-text="textForTooltip(complexResult.type)"></info-tooltip>
                    </div>
                    <!-- End of mobile resp.-->
                    <div class="col-3 col-lg-12 text-center">
                        <p>{{ complexResult.socialSecurityRefundAmount + ' €' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="complementaryRefund" :class="columnForLabels"><strong>{{ text.complementaryRefund }}</strong></label>
            <div v-for="complexResult in complexRefundResults" :key="complexResult.type" :class="columnForResults">
                <div class="row">
                    <!-- Mobile resp. labels -->
                    <div class="d-block d-lg-none col-9">
                        <label>{{ textFromType(complexResult.type) }}</label>
                    </div>
                    <!-- End of mobile resp.-->
                    <div class="col-3 col-lg-12 text-center">
                        <p>{{ complexResult.complementaryRefundAmount + ' €' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label for="leftToPay" :class="columnForLabels + ' font-weight-bold'">{{ text.leftToPay }}</label>
            <div v-for="complexResult in complexRefundResults" :key="complexResult.type" :class="columnForResults">
                <div class="row">
                    <!-- Mobile resp. labels -->
                    <div class="d-block d-lg-none col-9">
                        <label>{{ textFromType(complexResult.type) }}</label>
                    </div>
                    <!-- End of mobile resp.-->
                    <div class="col-3 col-lg-12 text-center">
                        <p>{{ complexResult.leftToPayAmount + ' €' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import resources from '../helpers/resources'
import Branding from '../helpers/branding'

export default {
    data() { 
        return {
            text: resources,
            columnForResults: "col-lg-3 col-12",
            opticalCareColumnForLabel: "col-lg-3 col-12",
            medicalCareColumnForLabel: "col-lg-6 col-12",
        }
    },
    methods: {
        textFromType(resultType) {
            if (resultType === "O") { return this.text.OPTAM }
            if (resultType === "NO") { return this.text.nonOPTAM }
            if (resultType === "S") { return this.text.simpleGlass }
            if (resultType === "C") { return this.text.complexGlass }
            if (resultType === "TC") { return this.text.veryComplexGlass }
        },
        textForTooltip(resultType) {
            if (resultType === "O") { return this.text.optamInfo }
            if (resultType === "S") { return this.text.simpleGlassTooltip }
            if (resultType === "C") { return this.text.complexGlassTooltip }
            if (resultType === "TC") { return this.text.veryComplexGlassTooltip }
        }
    },
    computed: {
        columnForLabels() { 
            if (this.refundResults.simulationType === "O") { return this.opticalCareColumnForLabel }
            if (this.refundResults.simulationType === "C") { return this.medicalCareColumnForLabel }
        },
        refundResults () { return this.$store.state.refundResults },
        complexRefundResults () { return this.$store.state.complexRefundResults },
        leftToPayClass () { return Branding.getLeftToPayClass() }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ComplexResults.vue